import {
  composeValidators,
  maxValue,
  minValue,
  numberValidator,
} from '@flow/libs/forms/validators';
import { useMemo } from 'react';
import { t } from '@app/components/translation';

export function useDaysValidations() {
  const oneYearInDays = 365;
  const MIN_DAYS = 1;
  const MAX_DAYS = 10 * oneYearInDays;

  return useMemo(
    () =>
      composeValidators(
        numberValidator({
          text: t('This is not a valid number', {
            _comment: 'Generic validation message for number validator',
          }),
        }),
        minValue({
          t,
          field: t('Days', {
            _comment: 'Field name used in validation of automation rules.',
          }),
          limit: MIN_DAYS,
        }),
        maxValue({
          t,
          field: t('Days', {
            _comment: 'Field name used in validation of automation rules.',
          }),
          limit: MAX_DAYS,
        }),
      ),
    [
      MAX_DAYS,
    ],
  );
}
